export interface ILoyaltyItem {
  percentageValue?: number | null;
  localizedNavigationName?: string | null;
  discountType?: EDiscountType | null;
  loyaltyType: ELoyaltyType;
  value: number;
  state: EBenefitState;
  tags: EConflictTag[];
  orderPriceActivationThresholdWithVat: number;
  minimalOrderPriceThresholdWithVat: number;
  expirationDate?: Date | null;
  validUntil?: Date | null;
}

export enum EDiscountType {
  PERCENTAGE = 'Percentage',
  ABSOLUTE_WITH_VAT = 'AbsoluteWithVat',
  ABSOLUTE_WITHOUT_VAT = 'AbsoluteWithoutVat',
}

export enum ELoyaltyType {
  FREE_DELIVERY = 'FreeDelivery',
  BRAND_DISCOUNT = 'BrandDiscount',
  CATEGORY_DISCOUNT = 'CategoryDiscount',
}

export enum EBenefitState {
  ACTIVE = 'Active',
  DISABLED = 'Disabled',
  NOT_EXIST_FOR_USER = 'NotExistForUser',
}

export enum EConflictTag {
  CONFLICT_WITH_VOUCHER = 'ConflictWithVoucher',
  CONFLICT_WITH_OTHER_BENEFIT = 'ConflictWithOtherBenefit',
  NEWSLETTER_UNSUBSCRIBED = 'NewsletterUnsubscribed',
  TRESHOLD_NOT_REACHED = 'TresholdNotReached',
}
